import { render } from "./ProjectPendenciasSection.vue?vue&type=template&id=79934c5d&scoped=true&ts=true"
import script from "./ProjectPendenciasSection.vue?vue&type=script&lang=ts"
export * from "./ProjectPendenciasSection.vue?vue&type=script&lang=ts"

import "./ProjectPendenciasSection.vue?vue&type=style&index=0&id=79934c5d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79934c5d"]])

export default __exports__